/* global CustomEvent */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'custom-event-polyfill/polyfill';
import { Cross } from '../../helpers/icon-dictionary';
import { ClearButton, TextInputComponent, InputWrapper } from './styled';

const WAIT_INTERVAL = 500;

class TextInput extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { value: '' };
        this.handleClearText = this.handleClearText.bind(this);
        this.onChange = this.onChange.bind(this);
        this.triggerChange = this.triggerChange.bind(this);
    }

    handleClearText() {
        const { clearText } = this.props;
        if (clearText && this.inputEl.value !== '') {
            this.inputEl.value = '';
            const event = new CustomEvent('input', { bubbles: true });
            this.inputEl.dispatchEvent(event);
            this.onChange(event);
        }
    }

    onChange(e) {
        clearTimeout(this.timer);
        this.setState({ value: e.target.value });
        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }

    triggerChange() {
        const { handleOnChange = () => {} } = this.props;
        const { value } = this.state;
        handleOnChange(value);
    }

    render() {
        const { clearText } = this.props;

        let inputProps = {};
        let clearEl = '';
        let hasClearText = '';

        // Add ref to the input component if clear text mode is enabled
        if (clearText) {
            hasClearText = false;
            inputProps = { ref: (el) => { this.inputEl = el; } };
            clearEl = (<ClearButton
                disabled={this.props.disabled}
                icon={Cross}
                iconClassName={'this.props.css.clearButtonIcon'}
                onClick={this.handleClearText}>x</ClearButton>);
        }

        return (
            <TextInputComponent className={`${hasClearText}`}>
                <InputWrapper
                    disabled={this.props.disabled}
                    maxLength={this.props.maxLength}
                    name={this.props.name}
                    onChange={this.onChange}
                    placeholder={this.props.placeholder}
                    type="text"
                    value={this.props.value}
                    {...inputProps}
                />{clearEl}
            </TextInputComponent>
        );
    }
}

TextInput.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    maxLength: PropTypes.number,
    placeholder: PropTypes.string,
    handleOnChange: PropTypes.func,
    disabled: PropTypes.bool,
    // Enable clear text mode and display a clear button
    clearText: PropTypes.bool
};

export default TextInput;




// WEBPACK FOOTER //
// ./app/components/text-input/index.js